const rankingItems = [
  { rank: 1, title: '社长大人是禽兽', tag: '韩漫', score: '9.7', trend: 'up', desc: '霸总恋爱天花板' },
  { rank: 2, title: '咒术回战', tag: '日漫', score: '9.6', trend: 'up', desc: '热血战斗巅峰之作' },
  { rank: 3, title: '我独自升级', tag: '韩漫', score: '9.5', trend: 'same', desc: '全球现象级韩漫' },
  { rank: 4, title: '一人之下', tag: '国漫', score: '9.4', trend: 'up', desc: '国漫世界观标杆' },
  { rank: 5, title: '女神降临', tag: '韩漫', score: '9.3', trend: 'down', desc: '完结热度不减' },
  { rank: 6, title: '间谍过家家', tag: '日漫', score: '9.3', trend: 'up', desc: '温馨喜剧人气王' },
  { rank: 7, title: '完美世界', tag: '国漫', score: '9.2', trend: 'up', desc: '仙侠国漫代表作' },
];

const getRankStyle = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-accent-300 text-background-50';
  if (rank === 3) return 'bg-accent-200 text-accent-800';
  return 'bg-background-200 text-foreground-600';
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">人气排行</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            皮皮漫画全网读者评分与热度综合排名，发现最受欢迎的漫画作品
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 md:gap-6 px-5 md:px-8 py-4 md:py-5 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-100' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 rounded-xl flex items-center justify-center font-heading text-lg shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-sm md:text-base text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                <span className="text-sm font-heading text-accent-500">{item.score}</span>
                {item.trend === 'up' && <i className="ri-arrow-up-fill text-accent-500 text-xs"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-fill text-foreground-400 text-xs"></i>}
                {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}